<template>
  <el-form-item :prop="prop">
    <el-input
      size="medium"
      @keyup.enter.native="submit"
      v-model="inputValue"
      auto-complete="off"
      placeholder="验证码"
      @input="updateVal"
      maxlength="6"
    >
      <el-button v-if="showTimer" type="text" class="text-primary h5" slot="suffix">
        <span class="text-one-gray">{{count}}s后重新获取</span>
      </el-button>
      <el-button
        v-else
        type="text"
        class="text-primary h5"
        slot="suffix"
        @click="sendSmsCode"
        :disabled="!checkPhone(phone) || !ckickFlag"
      >
        <span class>获取验证码</span>
      </el-button>
    </el-input>
  </el-form-item>
</template>

<script>
import { phoneNo } from "@/common/regex";

let msgBox = null;
export default {
  props: ["value", "phone", "prop",'ckickFlag'],
  data() {
    return {
      showTimer: false,
      count: 60,
      inputValue: this.value
    };
  },
  methods: {
    checkPhone(mobile) {
      return phoneNo.test(mobile);
    },
    async sendSmsCode() {            
      let params = {
        mobile: this.phone
      };      
      this.showTimer = true;    
      const res = await this.$store.dispatch('user/SEND_SMS_CODE',params)  
      this.setTimer();    
    },
    setTimer() {
      let _this = this;
      const timer = setInterval(() => {
        if (_this.count > 0) _this.count--;
        if (_this.count === 0) {
          clearInterval(timer);
          _this.count = 60;
          _this.showTimer = false;
        }
      }, 1000);
    },
    updateVal(value) {
      this.$emit("getValue", value);
    },
    changeCode() {
      this.inputValue = "";
    }
  }
};
</script>

<style scoped>
</style>
